import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation teams($id: ID!, $model: TeamInput!) {
  updateTeam(id: $id, team: $model){
    id
    name
    description
    visibleCasesCount
    overseers {
      id
      fullName
    }
    operators {
      id
      fullName
    }
    requestTypePriorities {
      channel {
        id
      }
      requestType {
        id
      }
    }
  }
}`;

function updateTeam(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateTeam);
}

export default updateTeam;
